import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'core/auth-guard/auth-guard.service';
import { UnsavedChangesGuard } from 'core/unsaved-changes/unsaved-changes-guard.class';
import { MobileGuard } from 'core/mobile-guard/mobile.guard.service';
import { NsLocaleGuard } from 'core/ns-locale-guard/ns-locale.guard';
import { InvoiceViewComponent } from './invoices/invoice-view/invoice-view.component';
import { InvoiceListComponent } from './invoices/invoices-list/invoices-list.component';
import { OrderListComponent } from './orders/order-list/order-list.component';
import { QuoteListComponent } from './quotes/quote-list/quote-list.component';
import { QuoteComponent } from './quotes/quote/quote.component';
import { PaymentBarclaysComponent } from './quotes/payment-barclays/payment-barclays.component';
import { BarclaysPaymentProcessingLegacyComponent } from
  './quotes/barclays-payment-processing-legacy/barclays-payment-processing-legacy.component';
import { LnOrderListComponent } from './ln-orders/ln-order-list/ln-order-list.component';
import { LnOrderComponent } from './ln-orders/ln-order/ln-order.component';

const routes: Routes = [
  {
    path: 'quotes/:customerId/new',
    component: QuoteComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'quotes/lead/:leadId/new',
    component: QuoteComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'quotes/new',
    component: QuoteComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'quotes/new/priceAs',
    component: QuoteComponent,
    canDeactivate: [UnsavedChangesGuard],
    data: { fromPriceAs: true }
  },
  {
    path: 'quotes/:quoteId/payment',
    component: PaymentBarclaysComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'barclays/payment-processing',
    component: BarclaysPaymentProcessingLegacyComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'quotes/:quoteId',
    component: QuoteComponent,
    canDeactivate: [UnsavedChangesGuard]
  },
  {
    path: 'quotes',
    component: QuoteListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'orders',
    component: OrderListComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'ln-orders',
    component: LnOrderListComponent,
    canActivate: [AuthGuard, MobileGuard, NsLocaleGuard],
  },
  {
    path: 'ln-orders/:lnOrderNumber',
    component: LnOrderComponent,
    canDeactivate: [UnsavedChangesGuard],
    canActivate: [NsLocaleGuard]
  },
  {
    path: 'invoices',
    component: InvoiceListComponent,
    canActivate: [AuthGuard, MobileGuard, NsLocaleGuard],
  },
  {
    path: 'invoices/:invoiceNumber',
    component: InvoiceViewComponent,
    canDeactivate: [UnsavedChangesGuard],
    canActivate: [NsLocaleGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class PosRoutingModule { }
